import request from '@/api/request.js'

// 查询组织架构树
export function getOrgTree(param) {
  return request({
    url: 'oa/org/tree',
    method: 'get',
    params: param
  })
}

// 获取案件类型
export function getCaseCate() {
  return request({
    url: 'cases/categories',
    method: 'get'
  })
}

export function getuserinfo() {
  return request({
    url: 'cases/userbyid',
    method: 'get'
  })
}

// 搜索人员
export function getUserByName(param) {
  return request({
    url: 'oa/org/tree/user/search',
    method: 'get',
    params: param
  })
}

// 登录
export function login(data) {
  return request({
    url: 'login',
    method: 'post',
    data
  })
}

// 获取律师列表 cases/lawyerlist
export function getLawyerList() {
  return request({
    url: 'cases/lawyerlist',
    method: 'get'
  })
}

// 创建案件 cases/create
export function createCase(data) {
  return request({
    url: 'cases/create',
    method: 'post',
    data
  })
}

// 获取案件列表 cases/list
export function getCaseList(params) {
  return request({
    url: 'cases/list',
    method: 'get',
    params
  })
}

// 获取案件信息 cases/info
export function getCaseInfo(params) {
  return request({
    url: 'cases/info',
    method: 'get',
    params
  })
}

// 更新案件信息 cases/caseinfoupdate
export function updateCase(data) {
  return request({
    url: 'cases/caseinfoupdate',
    method: 'post',
    data
  })
}

// 删除案件 cases/deletecase
export function deleteCase(params) {
  return request({
    url: 'cases/deletecase',
    method: 'post',
    data: params
  })
}

// 添加案件查看人员 cases/addviewer
export function addCaseViewer(data) {
  return request({
    url: 'cases/addviewer',
    method: 'post',
    data
  })
}

// 更新案件承办人 cases/updatehandler
export function updateCaseHandler(data) {
  return request({
    url: 'cases/updatehandler',
    method: 'post',
    data
  })
}

// 添加节点工作记录 cases/addworklog
export function addNodeWorkLog(data) {
  return request({
    url: 'cases/addworklog',
    method: 'post',
    data
  })
}

// 更新节点表单 cases/savenodeform
export function updateNodeForm(data) {
  return request({
    url: 'cases/savenodeform',
    method: 'post',
    data
  })
}

// 手动发送节点消息nodemessagesend
export function sendNodeMessage(data) {
  return request({
    url: 'cases/nodemessagesend',
    method: 'post',
    data
  })
}

// 手机号登录
export function loginByPhone(data) {
  return request({
    url: 'login/mobile',
    method: 'post',
    data
  })
}

// 发送短信验证码
export function sendSmsCode(data) {
  return request({
    url: 'register/verify',
    method: 'post',
    data
  })
}

// 上传节点文件
export function uploadNodeFile(data) {
  return request({
    url: 'upload/file',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 上传图片
export function uploadImage(data) {
  return request({
    url: 'upload/image',
    method: 'post',
    data
  })
}

// 清除节点用户表单 cases/clearclientform
export function clearNodeClientForm(data) {
  return request({
    url: 'cases/clearclientform',
    method: 'post',
    data
  })
}

// 获取案件流程阶段 cases/getsetup
export function getCaseSetup(params) {
  return request({
    url: 'cases/getsetup',
    method: 'get',
    params
  })
}

// 获取阶段节点 cases/getnodes
export function getCaseNodes(params) {
  return request({
    url: 'cases/getnodes',
    method: 'get',
    params
  })
}

// 更新工作记录客户可见状态 cases/worklog/visible
export function updateWorkLogVisible(data) {
  return request({
    url: 'cases/worklog/visible',
    method: 'post',
    data
  })
}

// 删除工作记录 cases/worklog/delete
export function deleteWorkLog(data) {
  return request({
    url: 'cases/worklog/delete',
    method: 'post',
    data
  })
}

// 获取节点信息 cases/getnodeinfo
export function getNodeInfo(params) {
  return request({
    url: 'cases/getnodeinfo',
    method: 'get',
    params
  })
}

// 获取案件工作记录列表 cases/worklogs
export function getCaseWorkLogs(params) {
  return request({
    url: 'cases/worklogs',
    method: 'get',
    params
  })
}

// 获取案件消息记录 cases/messages
export function getCaseMessages(params) {
  return request({
    url: 'cases/messages',
    method: 'get',
    params
  })
}

// 更新节点自动发送时间 cases/updatenodeautotime
export function updateNodeAutoTime(data) {
  return request({
    url: 'cases/updatenodeautotime',
    method: 'post',
    data
  })
} 

// 完成节点 cases/complete
export function completeNode(data) {
  return request({
    url: 'cases/complete',
    method: 'post',
    data
  })
}





//取消结案 qxjiean
export function qxjiean(data) {
  return request({
    url: 'cases/qxjiean',
    method: 'post',
    data
  })
}


// 完成案件 cases/casecomplete
export function completeCase(data) {
  return request({
    url: 'cases/casecomplete',
    method: 'post',
    data
  })
}


// 取消案件 cases/casecancel
export function cancelCase(data) {
  return request({
    url: 'cases/casecancel',
    method: 'post',
    data
  })
}

// 获取案件日程设置节点列表 cases/schedulesetlist
export function getCaseSchedule(params) {
  return request({
    url: 'cases/schedulesetlist',
    method: 'get',
    params
  })
}

// 更新案件客户可见状态 cases/updateclientview
export function updateClientView(data) {
  return request({
    url: 'cases/updateclientview',
    method: 'post',
    data
  })
}

// 更新案件日程设置 cases/setcaseschedule
export function setCaseSchedule(data) {
  return request({
    url: 'cases/setcaseschedule',
    method: 'post',
    data
  })
}

// 获取节点打印信息 cases/getnodeprintinfo
export function getNodePrintInfo(params) {
  return request({
    url: 'cases/getnodeprintinfo',
    method: 'get',
    params
  })
}

// 创建日程 cases/schedulecreate
export function createSchedule(data) {
  return request({
    url: 'cases/schedulecreate',
    method: 'post',
    data
  })
}

// 获取日程列表 cases/schedulelist
export function getScheduleList(params) {
  return request({
    url: 'cases/schedulelist',
    method: 'get',
    params
  })
}

// 更新日程状态 cases/schedulestatus
export function updateScheduleStatus(data) {
  return request({
    url: 'cases/schedulestatus',
    method: 'post',
    data
  })
}

// 更新日程 cases/scheduleupdate
export function updateSchedule(data) {
  return request({
    url: 'cases/scheduleupdate',
    method: 'post',
    data
  })
}

// PC端 修改密码 cases/changepassword
export function changePassword(data) {
  return request({
    url: 'cases/changepassword',
    method: 'post',
    data
  })
}



// 添加人员 cases/addPerson
export function addPerson(data) {
  return request({
    url: 'cases/addPerson',
    method: 'post',
    data
  })
}

// 更新人员 cases/updatePerson
export function updatePerson(data) {
  return request({
    url: 'cases/updatePerson',
    method: 'post',
    data
  })
}


// 删除人员 cases/deletePerson
export function deletePerson(data) {
  return request({
    url: 'cases/deletePerson',
    method: 'post',
    data
  })
}



export default {
  getOrgTree, getUserByName, getCaseCate, login, getuserinfo, getLawyerList, createCase, getCaseList, getCaseInfo, updateCase, deleteCase, addCaseViewer, updateCaseHandler, addNodeWorkLog, updateNodeForm, sendNodeMessage, loginByPhone, sendSmsCode, uploadNodeFile, uploadImage, clearNodeClientForm, getCaseSetup, getCaseNodes, updateWorkLogVisible, deleteWorkLog, getNodeInfo, getCaseWorkLogs, getCaseMessages, updateNodeAutoTime, completeNode, completeCase, cancelCase, getCaseSchedule, updateClientView, setCaseSchedule, getNodePrintInfo, createSchedule, getScheduleList, updateScheduleStatus, updateSchedule, changePassword, addPerson, updatePerson, deletePerson
}
